export default [
  {
    path: '',
    name: 'facturacion',
    component: () => import(/* webpackChunkName: "facturacion" */ '@/apps/facturacion/pages/FacturacionPage.vue')
  },
  {
    path: '/facturacion-emision',
    name: 'facturacion-emision',
    component: () => import(/* webpackChunkName: "facturacion-emision" */ '@/apps/facturacion/pages/FacturacionEmision.vue')
  },
  {
    path: '/facturacion-emision/revision-nota',
    name: 'facturacion-revision-nota',
    component: () => import(/* webpackChunkName: "facturacion-revision-nota" */ '@/apps/facturacion/pages/FacturacionRevisionNota.vue')
  },
  {
    path: '/facturacion/revision',
    name: 'facturacion-revision',
    component: () => import(/* webpackChunkName: "facturacion-revision" */ '@/apps/facturacion/pages/FacturacionRevision.vue')
  },
  {
    path: '/facturacion-credito',
    name: 'facturacion-credito',
    component: () => import(/* webpackChunkName: "facturacion-credito" */ '@/apps/facturacion/pages/FacturacionCreditoPage.vue')
  },
  {
    path: '/facturacion-credito/revision',
    name: 'facturacion-credito-revision',
    component: () => import(/* webpackChunkName: "facturacion-credito-revision" */ '@/apps/facturacion/pages/FacturacionRevision.vue')
  }
  ,
  {
    path: '/cobros',
    name: 'facturacion-cobros',
    component: () => import(/* webpackChunkName: "facturacion-cobros" */ '@/apps/facturacion/pages/FacturacionCobrosPage.vue')
  },
  {
    path: '/cobrar-notas',
    name: 'cobrar-notas',
    component: () => import(/* webpackChunkName: "facturacion-cobros-notas" */ '@/apps/facturacion/pages/FacturacionCobrosNotasPage.vue')
  },
  {
    path: '/facturas-emitidas',
    name: 'facturas-emitidas',
    component: () => import(/* webpackChunkName: "facturacion-cobros" */ '@/apps/facturacion/pages/FacturasEmitidas.vue')
  },
  {
    path: '/facturacion-folios',
    name: 'facturacion-folios',
    component: () => import(/* webpackChunkName: "facturacion-folios" */ '@/apps/facturacion/pages/FacturacionFolios.vue')
  },
  {
    path: '/visualizar-xml',
    name: 'visualizar-xml',
    component: () => import(/* webpackChunkName: "visualizar-xml" */ '@/apps/facturacion/pages/VisualizarXml.vue')
  },
  {
    path: '/export-iempresario',
    name: 'export-iempresario',
    component: () => import(/* webpackChunkName: "export-iempresario" */ '@/apps/facturacion/pages/ExportIempresario.vue')
  }
]
